import { Injectable } from '@angular/core';

@Injectable({
  providedIn: "root"
})
export class SessionStorageService {
  getItem(key: string, convertToJSON?: boolean): any {
    let data = sessionStorage.getItem(key);

    if (convertToJSON) {
      try {
        data = JSON.parse(data);
      } catch (e) {}
    }

    return data;
  }

  setItem(key: string, data: any, convertToString?: boolean): void {
    let dataLocal = data;

    try {
      if (convertToString) {
        dataLocal = JSON.stringify(dataLocal);
      }

      sessionStorage.setItem(key, dataLocal);
    } catch (e) {}
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }
}
